// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__NfMB-","footer":"ModalFilter_footer__37P6y"};